import React from 'react';
import { NavLink } from 'react-router-dom';
import { alpha, Box, Button, useMediaQuery } from '@mui/material';
import { DefaultTheme } from '@mui/styles';

export default function HeaderSignUpMenu() {
	const isMobile = useMediaQuery((theme: DefaultTheme) => theme.breakpoints.down('md'));
	const htmlTag = isMobile ? 'div' : 'span';

	return (
		<Box>
			<Box component={htmlTag} mb={isMobile ? 2 : 0} data-cy="sign-in-button">
				<Button
					component={NavLink}
					to="/login"
					variant="outlined"
					sx={{
						marginRight: 2,
						color: (theme) =>
							alpha('light' === theme.palette.mode ? '#000' : '#fff', 0.87),
						borderColor: (theme) =>
							alpha('light' === theme.palette.mode ? '#000' : '#fff', 0.23),
					}}
					fullWidth={isMobile}
				>
					Sign In
				</Button>
			</Box>
			<Box component={htmlTag} data-cy="sign-up-button">
				<Button
					component={NavLink}
					to="/register"
					variant="contained"
					color="primary"
					fullWidth={isMobile}
				>
					Sign Up
				</Button>
			</Box>
		</Box>
	);
}
